// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_41f715d","icon":"_e580ea65","contentSection":"_36f6540e","title":"_a9f8ee6e","buttonWrapper":"_cc877d4b"};